import React, { useEffect, useState } from "react";
import { ActivityTracker } from "cai-fusion";
import { useNewTemplate } from "../../contexts/NewTemplateContext";

const SavingTemplateActivityTracker = ({isHidden, isEditing = true}) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { chatTemplate } = useNewTemplate();

    useEffect(() => {
        if (!isHidden) {
            setIsCollapsed(false);
        }
    }, [isHidden])

    return (
        <ActivityTracker
            message={`${isEditing ? "Saving" : "Creating"} ${`"${chatTemplate?.title}"` ?? "your template"}, please wait...`}
            isHidden={isHidden}
            isCollapsed={isCollapsed}
            onCollapse={(collapseState) => setIsCollapsed(collapseState)}
            hideProgressBar
        />
    )
}

export default SavingTemplateActivityTracker;